/*
  hfb-magic.js — Howielujah LLC bespoke motion + interaction (dependency-free).
  - Reveal chokepoint: one IntersectionObserver for every [data-hfb-reveal] element.
  - Word-stagger heading reveal (transcribed from magicui text-reveal).
  - SVG path-draw trigger (hero winged mark, 404 anchor).
  - Sticky mobile add-to-cart bar visibility.
  All effects are additive: with JS off or reduced-motion, content is fully visible.
*/
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal chokepoint ---- */
  function initReveal() {
    var targets = document.querySelectorAll('[data-hfb-reveal]');
    if (!targets.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---- Word-stagger: split [data-hfb-words] text into per-word spans ---- */
  function initWords() {
    var nodes = document.querySelectorAll('[data-hfb-words]');
    nodes.forEach(function (node) {
      if (node.dataset.hfbWordsDone) return;
      node.dataset.hfbWordsDone = '1';
      var words = node.textContent.trim().split(/\s+/);
      node.textContent = '';
      node.classList.add('hfb-words');
      words.forEach(function (w, i) {
        var span = document.createElement('span');
        span.className = 'hfb-word';
        span.style.setProperty('--_i', i);
        span.textContent = w;
        node.appendChild(span);
        if (i < words.length - 1) node.appendChild(document.createTextNode(' '));
      });
    });
  }

  /* ---- SVG path-draw: run once when [data-hfb-draw] enters view (or immediately) ---- */
  function initDraw() {
    var draws = document.querySelectorAll('[data-hfb-draw]');
    if (!draws.length) return;
    if (reduce) { draws.forEach(function (el) { el.classList.add('is-drawn'); }); return; }
    function run(el) {
      var paths = el.querySelectorAll('path, line, polyline');
      paths.forEach(function (p) {
        var len = 0;
        try { len = p.getTotalLength(); } catch (e) { len = 1200; }
        p.style.strokeDasharray = len;
        p.style.strokeDashoffset = len;
        // force reflow then animate
        p.getBoundingClientRect();
        p.style.transition = 'stroke-dashoffset 1.2s ease';
        p.style.strokeDashoffset = '0';
      });
      el.classList.add('is-drawn');
    }
    if (!('IntersectionObserver' in window)) { draws.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.35 });
    draws.forEach(function (el) { io.observe(el); });
  }

  /* ---- Sticky mobile add-to-cart bar: reveal after the buy box scrolls out ---- */
  function initStickyBar() {
    var bar = document.querySelector('[data-hfb-sticky-bar]');
    var anchor = document.querySelector('[data-hfb-buybox]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  function boot() { initWords(); initReveal(); initDraw(); initStickyBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // re-run in the theme editor when sections reload
  document.addEventListener('shopify:section:load', boot);
})();
